import { useAppSelector } from "../../api/hooks";
import type { IAboutContent } from "../../api/aboutSlice";
import "./aboutPage.css";

export const AboutPage = () => {
  const aboutSections:
    IAboutContent[] =
    Object.values(
      useAppSelector(
        (state) =>
          state.about
      )
    );

  return (
    <div className="about-page">
      <header className="page-intro">
        <div className="page-intro__eyebrow">
          Tarot Generator V2
        </div>

        <h1 className="page-intro__title">
          Генератор и интерпретатор
          раскладов Таро
        </h1>
      </header>

      <div className="about-page__content">
        {aboutSections.map(
          (
            {
              title,
              content,
            },
            index
          ) => (
            <section
              key={`${title}-${index}`}
              className="about-block"
            >
              <h2 className="about-block__title">
                {title}
              </h2>

              <div className="about-block__body">
                {content.map(
                  (
                    text,
                    textIndex
                  ) => (
                    <p
                      key={
                        textIndex
                      }
                      className="about-block__text"
                    >
                      {
                        text
                      }
                    </p>
                  )
                )}
              </div>
            </section>
          )
        )}
      </div>
    </div>
  );
};

